function customRuleForArabic(choice: number): number {
  if (choice === 0) {
    return 0; // Zero
  }
  if (choice === 1) {
    return 1; // Singular
  }
  if (choice === 2) {
    return 2; // Dual
  }
  if (choice >= 3 && choice <= 10) {
    return 3; // Few
  }
  return 4; // Many
}

export default customRuleForArabic;
